import OtherCommands from './OtherCommands.js'
import './other-commands.css'

export default OtherCommands
